import dayjs from 'dayjs';

export function formatDate(value) {
  if (!value) return value ?? '';

  return dayjs(value).format('DD/MM/YYYY');
}

/** `DD/MM/YYYY` as `YYYY-MM-DD`, or '' when it isn't a full date in that shape. */
export function brDateToIso(value) {
  const match = String(value ?? '').trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  return match ? `${match[3]}-${match[2]}-${match[1]}` : '';
}

/** Whether a `DD/MM/YYYY` birth date is at least `years` old on `today`. */
export function isAtLeastYearsOld(value, years, today = dayjs()) {
  const iso = brDateToIso(value);
  return !!iso && !dayjs(iso).isAfter(today.subtract(years, 'year'), 'day');
}
